import React, { useEffect, useState, useMemo, useRef } from "react";
import { toast } from "react-toastify";
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Button,
} from "@mui/material";
import MuiPhone from '../../../pages/campaign/MuiPhone';
import { isFieldDisabled } from "../../reusableComponent/FieldDisabled";
import { useUpdateCamapignDynamicFieldsMutation } from "../../../Services/campign/CampaignDetail";
import { useCampignsDynamicFieldsQuery } from "../../../Services/campign/campignList";
import { useTelephony } from "../../context/TelephonyContext";
import { TELEPHONY_LOGIN } from "../../../constants";
import {
  maskEmail,
  maskPhoneNumber,
} from "../../reusableComponent/MaskedFields";
import ConfirmationModal from "./ConfirmationModal";
import ReactModal from "react-modal";
import { useUserDynamicFieldsQuery } from "../../../Services/settingsAPIs/CommonAPI";
import { parsePhoneNumberFromString, isValidPhoneNumber, CountryCode } from 'libphonenumber-js';
import { PhoneInput } from "react-international-phone";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import { FILE_UPLOAD_URL } from "../../../env"; // Update path if needed
import Quotation from "./Quotation";
import { useCreateQuotationMutation } from "../../../Services/campign/CampaignDetail";
import parsePhoneNumber from 'libphonenumber-js';
import { MultiLevelDropdown } from "../../MultiLevelDropdown";

function getFullPathForDropdown(field: any, lastValue: string | null | undefined): string | null {
  if (!lastValue || !field?.multiple_level) return lastValue || null;
  // BFS or DFS to find the path
  const stack: { node: any; path: string[] }[] = field.multiple_level.map((node: any) => ({ node, path: [node.choice] }));
  while (stack.length > 0) {
    const { node, path } = stack.pop();
    if (node.choice === lastValue) {
      return path.join(' > ');
    }
    // check for next levels
    Object.keys(node).forEach((k) => {
      if (k.startsWith('level') && Array.isArray(node[k])) {
        node[k].forEach((child: any) => {
          stack.push({ node: child, path: [...path, child.choice] });
        });
      }
    });
  }
  return lastValue; // fallback
}

// Helper to get local number without country code
function getLocalPhoneNumber(phoneNumber: string, country: string): string {
  try {
    const parsed = parsePhoneNumber(phoneNumber, country.toUpperCase() as CountryCode);
    return parsed ? parsed.nationalNumber : phoneNumber;
  } catch {
    return phoneNumber;
  }
}

interface IProps {
  ticket: any;
  refetch: any;
  uuid: any;
  handleButtonClick: any;
  setConfirmationModalOpen: any;
  confirmationModalOpen: any;
  setLiftingObj: any;
  buttonClicked: any;
  scrollToTop: any;
  setIsStatusWonSelected: any;
  isStatusWonSelected: any;
  refetchLeadTrail: any;
  setPaneOpen: any;
}

const LeadInformationTab: React.FC<IProps> = ({
  ticket,
  refetch,
  uuid,
  handleButtonClick,
  setConfirmationModalOpen,
  confirmationModalOpen,
  setLiftingObj,
  scrollToTop,
  refetchLeadTrail,
  setPaneOpen,
}) => {
  const { data: ticketDynamicFields } = useCampignsDynamicFieldsQuery({});
  const [createQuotation] = useCreateQuotationMutation();
  const [dynamicFields, setDynamicFields] = useState<any>({});
  const [dynamicFieldData, setDynamicFieldData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [accountName, setAccountName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneCountry, setPhoneCountry] = useState("IN");

  const proposalRef = useRef(null);
  const [showQuotation, setShowQuotation] = useState(false);
  const [isLoadingQuotation, setIsLoadingQuotation] = useState(false);
  const [page, setPage] = useState(1)

  const [matchedDynamicFields, setMatchedDynamicFields] = useState<
    Record<string, any>
  >({});

  const modelName = "contact";
  const { data: contactDynamicData } = useUserDynamicFieldsQuery(modelName);

  useEffect(() => {
    if (!ticket?.dynamic_fields || !contactDynamicData) return;

    const updatedFields: Record<string, any> = {};

    contactDynamicData.forEach((el) => {
      const key = el?.label;
      if (ticket?.dynamic_fields?.hasOwnProperty(key)) {
        updatedFields[key] = ticket?.dynamic_fields[key]; // Store matched value
      }
    });

    setMatchedDynamicFields(updatedFields);
  }, [ticket?.dynamic_fields, contactDynamicData]);


  const [phoneNumber, setPhoneNumber] = useState("");
  const [updateDynamicFields] = useUpdateCamapignDynamicFieldsMutation();
  const [errors, setErrors] = useState<any>({});
  const { setLifitinMobileNumber, setMaskedLiftingMobileNumber } = useTelephony();

  const checkUserRole = localStorage.getItem("user_role");
  const checkUserTenant = localStorage.getItem("circleone-user");

  const handleInputChange = (key: string, value: any) => {
    // Check if value is in "date-time" format (e.g., ISO 8601 string or valid date)
    const field = dynamicFieldData.find((field) => field.label === key);
    if (
      !isNaN(new Date(value).getTime()) &&
      field?.field_type === "date-time"
    ) {
      // If the value is a valid date, process the date value
      const localDate = new Date(value);
      // If you want to store the date in UTC, use toISOString()
      const utcDate = new Date(localDate.toISOString());
      setDynamicFields((prevFields) => ({
        ...prevFields,
        [key]: utcDate.toISOString(), // Store as ISO string in UTC
      }));
    } else {
      // If the value is not a valid date-time, simply update the state with the value
      setDynamicFields((prevFields) => ({
        ...prevFields,
        [key]: value,
      }));
    }
  };

  const handleCheckboxChange = (
    event: React.ChangeEvent<{ value: any }>,
    key: string
  ) => {
    setDynamicFields((prevFields) => ({
      ...prevFields,
      [key]: event.target.value,
    }));
  };

  useEffect(() => {
    if (ticket) {
      setAccountName(ticket.account_name || "");
      setFirstName(ticket.first_name || "");
      setLastName(ticket.last_name || "");
      setEmail(ticket.email || "");
      setPhoneNumber(ticket.phone_number || "");
      setDynamicFields(ticket.dynamic_fields);
    }
  }, [ticket]);



  const validateForm = () => {
    const newErrors = {};

    dynamicFieldData.forEach((field) => {
      const fieldValue = dynamicFields[field.label];

      if (field.is_required && !fieldValue) {
        newErrors[field.label] = `${field.label} is required`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const getTeamId = localStorage.getItem("teamId");

  useEffect(() => {
    const updatedLeadInfoObj = {
      account: "",
      name: firstName,
      last_name: lastName,
      email: email,
      phone_number: phoneNumber,
      dynamic_fields: matchedDynamicFields, // Use parsed data
      tags: [],
      accessible_teams: [Number(getTeamId)],
    };

    setLiftingObj(updatedLeadInfoObj);
  }, [
    firstName,
    lastName,
    email,
    phoneNumber,
    matchedDynamicFields,
    getTeamId,
    setLiftingObj,
  ]);
  // Include editedFields in dependency array
  console.log(ticket, "ticket");
  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Please fill all required fields.");
      return;
    }
    const phoneNumberError = validatePhoneNumber(phoneNumber, phoneCountry);
    if (phoneNumberError) {
      setErrors({ phone_number: phoneNumberError });
      toast.error(phoneNumberError);
      return;
    }
    setIsLoading(true);

    const editedFields = Object.keys(dynamicFields).reduce((acc, key) => {
      const originalValue = ticket.dynamic_fields[key];
      const currentValue = dynamicFields[key];
      const field = dynamicFieldData.find((field) => field.label === key);
      // Check if the field has been changed
      if (originalValue !== currentValue) {
        if (field?.field_type === "date") {
          const formattedDate = new Date(currentValue)
            .toISOString()
            .replace("Z", "+00:00");
          acc[key] = formattedDate;
        } else {
          console.log(currentValue);
          acc[key] = currentValue;
        }
      }

      return acc;
    }, {});
    const updatedTicket = {
      account_name: accountName,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone_number: phoneNumber,
      dynamic_fields: editedFields || {},
      assigned_by: localStorage.getItem('circleone-username'),
      assignee: localStorage.getItem('User_Id'),
      status_type: ticket?.status_type
    };

    try {
      const response = await updateDynamicFields({
        variables: updatedTicket,
        uuid,
      });

      if (response.data) {
        // Successful API call
        setIsLoading(false); // Reset loading state
        toast.success("Information updated successfully!");
        refetch();
        refetchLeadTrail();
        setConfirmationModalOpen(true);
        scrollToTop();
      } else if (response.error) {
        // Handle error response
        const { status, data }: any = response.error;
        if (data?.email) {
          toast.error(data.email[0]); // Display email error message
          setErrors((prevErrors) => ({
            ...prevErrors,
            email: data.email[0],
          }));
        } else if (data?.detail) {
          data.detail.forEach((message) => {
            console.log(message, "messaggegg")
            toast.error(` ${message}`); // Display each error message
          });
        } else {
          toast.error(
            `Error ${status}: Something went wrong. Please try again.`
          );
        }
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false); // Reset loading state
      toast.error("Failed to assign. Please try again."); // Show error toast
      console.error(error); // Log the error
    }
  };

  // I want when any
  useEffect(() => {
    const generatePDF = async () => {
      if (!showQuotation || !proposalRef.current) return;
      setIsLoadingQuotation(true);
      const input = proposalRef.current;
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "a4"
      });
      const pageWidth = pdf.internal.pageSize.getWidth();
      // Save the current page state
      const originalPage = page;
      // Helper to wait for DOM update
      const wait = (ms: number) => new Promise(res => setTimeout(res, ms));

      // --- Capture Page 1 ---
      setPage(1);
      await wait(300); // Wait for React to re-render
      if (!proposalRef.current) return; // Defensive check
      let canvas1 = await html2canvas(proposalRef.current, { scale: 2, useCORS: true });
      let imgData1 = canvas1.toDataURL("image/png");
      let imgWidth1 = pageWidth;
      let imgHeight1 = canvas1.height * (pageWidth / canvas1.width);
      pdf.addImage(imgData1, "PNG", 0, 0, imgWidth1, imgHeight1);

      // --- Capture Page 2 ---
      setPage(2);
      await wait(300);
      if (!proposalRef.current) return;
      let canvas2 = await html2canvas(proposalRef.current, { scale: 2, useCORS: true });
      let imgData2 = canvas2.toDataURL("image/png");
      let imgWidth2 = pageWidth;
      let imgHeight2 = canvas2.height * (pageWidth / canvas2.width);
      pdf.addPage();
      pdf.addImage(imgData2, "PNG", 0, 0, imgWidth2, imgHeight2);

      // Restore original page state
      setPage(originalPage);
      await wait(100);

      // --- Get PDF as File ---
      const pdfBlob = pdf.output('blob');
      const pdfFile = new File([pdfBlob], 'business-proposal.pdf', { type: 'application/pdf' });
      const QUOTE_FIELDS = [
        "Price",
        "Discount %",
        "Variant",
        "Fuel Type",
        "Quotation No",
        "Quote Valid Upto",
      ];
      const updates: Record<string, any> = {};
      if (firstName !== (ticket.first_name || "")) {
        updates["First Name"] = firstName;
      }
      if (lastName !== (ticket.last_name || "")) {
        updates["Last Name"] = lastName;
      }
      QUOTE_FIELDS.forEach((field) => {
        const orig = ticket.dynamic_fields?.[field] ?? "";
        const curr = dynamicFields?.[field] ?? "";
        if (orig !== curr) {
          updates[field] = curr;
        }
      });

      try {
        const uploadResult = await pdfUpload(pdfFile);
        // Await the backend creation of the quotation before showing toast and switching pane
        await createQuotation({
          lead: uuid,
          quotation_url: uploadResult.url,
          updates,
        });
        toast.success("Quotation created successfully!");
        setPaneOpen("quotation");
      } catch (error) {
        toast.error("Failed to upload PDF.");
        setIsLoadingQuotation(false);
      }

      setShowQuotation(false);
      setIsLoadingQuotation(false);


    };

    generatePDF();
    // Only run when showQuotation changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showQuotation]);

  useEffect(() => {
    if (ticket?.campaign?.id) {
      const filterDataById = ticketDynamicFields?.filter(
        (name) => name?.campaign_name === ticket?.campaign?.id
      );
      setDynamicFieldData(filterDataById);
    }
  }, [ticketDynamicFields, ticket?.campaign?.id]);

  const gettingTelephonyStatus = localStorage.getItem(TELEPHONY_LOGIN);

  const closeConfirmationModal = () => {
    setConfirmationModalOpen(false);
  };

  const pdfUpload = async (file: File) => {
    setIsLoadingQuotation(true);
    try {
      const data = {
        files: [{ fileName: file.name, mimeType: file.type }],
      };
      // Expecting response.data to be an array of objects containing uploadURL, Key, url
      const response = await axios.post(FILE_UPLOAD_URL, data, {
        headers: { "Content-Type": "application/json" },
      });

      const { uploadURL, Key, url } = response.data[0];
      await axios.put(uploadURL, file, {
        headers: { "Content-Type": file.type },
      });

      return { Key, url };
    } catch (error) {
      setIsLoadingQuotation(false);
      throw error;
    }
  };

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "450px",
    },
  };
  const getFormattedDate = (date: string) => {
    if (!date) return "";

    const dt = new Date(date); // Parses the UTC date
    const year = dt.getFullYear();
    const month = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    const hours = String(dt.getHours()).padStart(2, "0");
    const minutes = String(dt.getMinutes()).padStart(2, "0");

    // Format for datetime-local in UTC, ignoring timezone conversions
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const validatePhoneNumber = (number: string, country: string = "IN") => {
    if (!number) return "Mobile number is required";
    try {
      const countryCode = country.toUpperCase() as CountryCode;
      const phoneObj = parsePhoneNumberFromString(number, countryCode);
      if (!phoneObj || !phoneObj.isValid()) {
        return `Invalid mobile number for country code ${country}`;
      }
      return "";
    } catch (e) {
      return `Invalid mobile number for country code ${country}`;
    }
  };
  const name = "lead";
  const checkTenant = localStorage.getItem("circleone-user");
  const maskedPhoneNumber = useMemo(() => {
    const tenantLower = checkTenant?.toLowerCase();
    const shouldMask = checkUserRole === "agent" && tenantLower === "briezi";
    
    if (shouldMask) {
      return maskPhoneNumber(phoneNumber);
    }
    return phoneNumber;
  }, [phoneNumber, checkUserRole, checkTenant]);

  return (
    <div className="card card-body">
      <form>
        <div className="row row-cols-3">
          <div className="col-xl-6 mb-3">
            <InputLabel>Account Name</InputLabel>
            <TextField
              variant="outlined"
              fullWidth
              value={accountName}
              onChange={(e) => setAccountName(e.target.value)}
            />
          </div>
          <div className="col-xl-6 mb-3">
            <InputLabel>First Name</InputLabel>
            <TextField
              variant="outlined"
              fullWidth
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="col-xl-6 mb-3">
            <InputLabel>Last Name</InputLabel>
            <TextField
              variant="outlined"
              fullWidth
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className="col-xl-6 mb-3">
            <InputLabel>Email</InputLabel>
            <TextField
              type="email"
              variant="outlined"
              fullWidth
              value={(checkUserRole === "agent" && checkTenant !== "botgo" && checkTenant !== "globtier" && checkTenant !== "globtierinternal") ? maskEmail(email) : email}
              onChange={(e) => {
                if (checkUserRole !== "agent") {
                  setEmail(e.target.value);
                }
              }}
            />
          </div>
        </div>

        <div className="row row-cols-3">
          <div className="col-xl-6 mb-3 ">
            <InputLabel className="required">Mobile No</InputLabel>
            <div 
              data-toggle="tooltip"
              data-placement="top"
              title={
                gettingTelephonyStatus === "true"
                  ? "Click to call"
                  : "Login telephony to call"
              }
              onClick={() => {
                if (gettingTelephonyStatus === "true") {
                  const numberWithoutCountryCode = getLocalPhoneNumber(phoneNumber, phoneCountry);
                  // Set real number for API calls
                  setLifitinMobileNumber(numberWithoutCountryCode);
                  localStorage.setItem("liftingMobileNumber", numberWithoutCountryCode);
                  
                  // Set masked number for display in telephony input (only for briezi tenant + agent role)
                  const tenantLower = checkTenant?.toLowerCase();
                  if (checkUserRole === "agent" && tenantLower === "briezi") {
                    const maskedNumber = maskPhoneNumber(numberWithoutCountryCode);
                    setMaskedLiftingMobileNumber(maskedNumber);
                    localStorage.setItem("maskedLiftingMobileNumber", maskedNumber);
                  } else {
                    setMaskedLiftingMobileNumber(numberWithoutCountryCode);
                    localStorage.setItem("maskedLiftingMobileNumber", numberWithoutCountryCode);
                  }
                }
              }}
              style={{ cursor: gettingTelephonyStatus === "true" ? "pointer" : "default" }}
            >
              <div style={{ pointerEvents: checkUserRole === "agent" && checkTenant === "briezi" ? "none" : "auto" }}>
                <MuiPhone
                  value={phoneNumber}
                  inputProps={{
                    value: maskedPhoneNumber,
                    readOnly: checkUserRole === "agent" && checkTenant === "briezi",
                  }}
                  onChange={(phone) => {
                    if (!(checkUserRole === "agent" && checkTenant === "briezi")) {
                      setPhoneNumber(phone);
                    }
                  }}
                  phoneCountry={phoneCountry}
                  onCountryChange={(countryIso2) => {
                    if (!(checkUserRole === "agent" && checkTenant === "briezi")) {
                      setPhoneCountry(countryIso2);
                    }
                  }}
                  fullWidth
                  disabled={checkUserRole === "agent" && checkTenant === "briezi"}
                />
              </div>
            </div>
            {errors.phone_number && (
              <div className="mt-2" style={{ color: "red" }}>
                {errors.phone_number}
              </div>
            )}
          </div>

          {dynamicFieldData?.map((field: any) => (
            <>
              {field.field_type !== "multi-level" ? (
                <div key={field.label} className="col-xl-6 mb-3">
                  {field.field_type !== "multi-level" && (
                    <InputLabel htmlFor={`dynamic_fields.${field.label}`}>
                      {field.label}
                      {field.is_required && <span className="required"></span>}
                    </InputLabel>
                  )}
                  {field.field_type === "text" && (
                    <TextField
                      id={`dynamic_fields.${field.label}`}
                      variant="outlined"
                      disabled={isFieldDisabled(field?.is_editable)}
                      fullWidth
                      value={dynamicFields[field.label] || ""}
                      onChange={(e) =>
                        handleInputChange(field.label, e.target.value)
                      }
                      required={field.is_required}
                    />
                  )}
                  {field.field_type === "email" && (
                    <TextField
                      type="email"
                      id={`dynamic_fields.${field.label}`}
                      disabled={isFieldDisabled(field?.is_editable)}
                      variant="outlined"
                      fullWidth
                      value={dynamicFields[field.label] || ""}
                      onChange={(e) =>
                        handleInputChange(field.label, e.target.value)
                      }
                      required={field.is_required}
                    />
                  )}
                  {field.field_type === "number" && (
                    <TextField
                      type="number"
                      id={`dynamic_fields.${field.label}`}
                      disabled={isFieldDisabled(field?.is_editable)}
                      variant="outlined"
                      fullWidth
                      value={dynamicFields[field.label] || ""}
                      onChange={(e) =>
                        handleInputChange(field.label, e.target.value)
                      }
                      required={field.is_required}
                    />
                  )}
                  {field.field_type === "date" && (
                    <TextField
                      type="date"
                      id={`dynamic_fields.${field.label}`}
                      disabled={isFieldDisabled(field?.is_editable)}
                      variant="outlined"
                      fullWidth
                      value={dynamicFields[field.label] || ""}
                      onChange={(e) =>
                        handleInputChange(field.label, e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        inputProps: {
                          style: { textTransform: "uppercase" }, // Optional: uppercase input text
                        },
                      }}
                      required={field.is_required}
                    />
                  )}
                  {field.field_type === "time" && (
                    <TextField
                      type="time"
                      id={`dynamic_fields.${field.label}`}
                      disabled={isFieldDisabled(field?.is_editable)}
                      variant="outlined"
                      fullWidth
                      value={dynamicFields[field.label] || ""}
                      onChange={(e) =>
                        handleInputChange(field.label, e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                      required={field.is_required}
                    />
                  )}
                  {field.field_type === "text-area" && (
                    <TextField
                      id={`dynamic_fields.${field.label}`}
                      disabled={isFieldDisabled(field?.is_editable)}
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      value={dynamicFields[field.label] || ""}
                      onChange={(e) =>
                        handleInputChange(field.label, e.target.value)
                      }
                      required={field.is_required}
                    />
                  )}

                  {field.field_type === "drop-down" && (
                    <FormControl fullWidth>
                      <Select
                        labelId={`select-label-${field.label}`}
                        disabled={isFieldDisabled(field?.is_editable)}
                        id={`select-${field.label}`}
                        value={dynamicFields[field.label] || ""}
                        onChange={(e) =>
                          handleInputChange(field.label, e.target.value)
                        }
                        required={field.is_required}
                      >
                        {field?.choices?.map((option: any) => (
                          <MenuItem key={option.id} value={option.choice}>
                            {option.choice}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                  {field.field_type === "check-box" && (
                    <FormControl fullWidth>
                      <Select
                        labelId={`checkbox-label-${field.label}`}
                        disabled={isFieldDisabled(field?.is_editable)}
                        id={`checkbox-${field.label}`}
                        multiple
                        value={dynamicFields[field.label] || []}
                        onChange={(e: any) => handleCheckboxChange(e, field.label)}
                        renderValue={(selected) => {
                          // Create an array of selected choice labels
                          const selectedLabels = (field?.multiple_choices || [])
                            .filter((choice: any) =>
                              selected.includes(String(choice.id))
                            )
                            .map((choice) => choice.choice);
                          return selectedLabels.join(", ");
                        }}
                      >
                        {field?.multiple_choices?.map((choice: any) => (
                          <MenuItem key={choice.id} value={String(choice.id)}>
                            <Checkbox
                              checked={dynamicFields[field.label]?.includes(
                                String(choice.id)
                              )}
                            />
                            <ListItemText primary={choice.choice} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  {field.field_type === "tel-phone" && (
                    <div style={{ display: "flex", width: "100%" }}>
  <MuiPhone
                        disabled={isFieldDisabled(field?.is_editable)}
                        value={dynamicFields[field.label] || "+91"}
                        onChange={(value) => handleInputChange(field.label, value)}
                        phoneCountry={phoneCountry}
                        onCountryChange={setPhoneCountry}
                      />
                    </div>
                  )}
                  {field.field_type === "date-time" && (
                    <TextField
                      type="datetime-local"
                      id={`dynamic_fields.${field.label}`}
                      disabled={isFieldDisabled(field?.is_editable)}
                      variant="outlined"
                      fullWidth
                      value={
                        getFormattedDate(dynamicFields[field.label]) ||
                        dynamicFields[field.label] ||
                        ""
                      }
                      onChange={(e) =>
                        handleInputChange(field.label, e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        inputProps: {
                          style: { textTransform: "uppercase" }, // Optional: uppercase input text
                        },
                      }}
                      required={field.is_required}
                    />
                  )}
                </div>
              ) : (
                <>
                  {field.field_type === "multi-level" && (
                    <MultiLevelDropdown
                      field={field}
                      value={getFullPathForDropdown(field, dynamicFields[field.label])}
                      onFinalSelect={(lastChoice, fullPath) => {
                        // Save the full path (e.g., "India > Uttar Pradesh") to dynamic fields
                        setDynamicFields(prev => ({
                          ...prev,
                          [field.label]: fullPath || lastChoice.choice
                        }));
                      }}
                      className="col-xl-6 mb-3"
                    />
                  )}
                </>
              )}
            </>
          ))}
        </div>
        <div className="row mt-5">
          <div className="d-flex justify-content-end p-2 m-2">
            {((checkUserTenant === "stage" || checkUserTenant === "vecv" || checkUserTenant === "meta") && ticket?.status_display !== "Rejected") && (
              <Button
                type="button"
                className="btn btn-primary me-2"
                onClick={() => setShowQuotation(true)}
                disabled={isLoadingQuotation}
              >
                {isLoadingQuotation ? "Loading..." : "Get Quote"}
              </Button>
            )}
            <Button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </Button>
          </div>
        </div>
      </form>

      <ReactModal
        isOpen={confirmationModalOpen}
        onRequestClose={closeConfirmationModal}
        style={customModalStyles}
        contentLabel="Change Status"
        shouldCloseOnOverlayClick={false}
      >
        <ConfirmationModal
          handleButtonClick={handleButtonClick}
          closeModal={closeConfirmationModal}
          name={name}
        />
      </ReactModal>
      {showQuotation && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            minHeight: "100vh",
            background: "#fff",
            zIndex: 9999,
            opacity: 0,
            pointerEvents: "none",
          }}
        >
          <Quotation data={dynamicFields} proposalRef={proposalRef} page={page} setPage={setPage} firstName={firstName} lastName={lastName} email={email} />
        </div>
      )}
    </div>
  );
};

export default LeadInformationTab;